import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchBoxSettings, updateBoxSettings } from '../api/boxSettings';
import type { BoxSettings, BoxSettingsUpdate } from '@deposits/shared';

export function useBoxSettings(enabled = true) {
  return useQuery<BoxSettings>({
    queryKey: ['box-settings'],
    queryFn: fetchBoxSettings,
    enabled,
    staleTime: 60_000,
  });
}

export function useUpdateBoxSettings() {
  const qc = useQueryClient();
  return useMutation<BoxSettings, Error, BoxSettingsUpdate>({
    mutationFn: updateBoxSettings,
    onSuccess: (data) => {
      qc.setQueryData(['box-settings'], data);
      // Changing cash_mode / handles_* reshapes which receipts the pending
      // screen shows, so refresh it too.
      qc.invalidateQueries({ queryKey: ['receipts-pending'] });
      // Turning manage_projects on needs the discovered project list.
      qc.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}
